import { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { ToastContainer, toast } from "react-toastify";
import DataTable from 'react-data-table-component'
import useCrud from '../../hooks/use_crud';
import "react-toastify/dist/ReactToastify.css";
import "./order_types_view.css";
import LoadingSpinner from '../../components/my-components/loading_spinner';
import CreateOrderTypeModal from './create_order_types_modal';
import IconButton from '../../components/my-components/my_icon_button';
import EditOrderTypeModal from './edit_order_type_modal';
import GroupBtn from '../../components/buttons/groupBtn';
import { add_text, delete_text, edit_text,delete_modal_text, order_type_classname_text, order_type_title_text, view_details_text, order_title_text } from '../../constant';
import { Link } from 'react-router-dom';
import Breadcrumb from '../../components/common/breadcrumb';
import ConfirmationModal from '../../components/my-components/confirmation-modal';
import XToggleButton from '../../components/my-components/xtoggle_button';



const OrdertypesView = () =>{

    const [loading,setLoading] = useState(false)
    const {list, create, edit, Delete, find, totalElements} = useCrud({url: "ordertypes", setLoading: setLoading, firstLoad:false})
   
    const [selectedRow, setSelectedRow] = useState({extrafields: []})

    const [filters, setFilters] = useState({});
    const [createModalIsOpen, setCreateModalIsOpen] = useState(false);
    const [editModalIsOpen, setEditModalIsOpen] = useState(false);
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false)
    const [confirmationModalData, setConfirmationModalData] = useState({
        description:'',
        onSubmit:()=>{},
        onCancel:()=>setIsConfirmationModalOpen(false)
    })

    
    const onCreate = async (orderType) => {
        if(!orderType.name || orderType.name === ""){
            toast.error("There are some empty fields. Please, try again")
            return
        }

        

        create(orderType)
          .catch(error => toast.error("Upps, there are some errors. Please, try again")
      )
      
      setCreateModalIsOpen(false);
    }

    const onEdit = async (orderType) => {

        if(!orderType.name || orderType.name === ""){
                toast.error("There are some empty fields. Please, try again")
                return
            }


            edit(orderType)
          .catch(error => toast.error("Upps, there are some errors. Please, try again")
      )
      
      setEditModalIsOpen(false);
    }

    useEffect(()=>{
        find(filters)
    },[filters])
    
   
    useEffect(()=>{
        let filtersAux = {}
       
        setFilters(filtersAux)
    },[])

    

    const columns = [
      {name: 'Id de Tipo de Orden',minWidth: '200px',selector: (row) =>row.id,sortable: true,center:true,},
      {name: 'Nombre',selector: (row) =>row.name,sortable: true,center:true,},
      {name: 'Descripción',selector: (row) => row.description,sortable: false,center:true},
      {name: 'Habilidado',selector: (row) => row.active,sortable: false,center:true},
      {name: 'Acciones',selector: (row) =>row.actions,sortable: false,center:true},

    ];

    const handleDelete = async (id) => {

        setIsConfirmationModalOpen(true)
        setConfirmationModalData({
            ...confirmationModalData,
            description: `${delete_modal_text}${order_type_classname_text}?`,
            onSubmit: async ()=>{
                try{
                    await Delete(id)
                   }
                   catch(e){
                       toast.error("No es posible eliminar un tipo de orden con ordenes existentes")
                   }
                setIsConfirmationModalOpen(false)
            }
        })
    };

    const handlePageChange = page => {
        find(filters,{size:10,page:page-1});
      };


    const handlePerRowsChange = async (newPerPage, page) => {
        find(filters,{size:newPerPage,page:page});

      };

    const updateTypeActive = async (type) => {
        type.disabled = !type.disabled;
        await edit(type);
        toast.success("Actualizado correctamente");
    };
    

    return (
        <div>
            <Breadcrumb parent={order_title_text} title={order_type_title_text}/>
            <br/>
            <div style={{display:"flex"}}>
                <div className='btn-right-container'>
                    <Button className='btn btn-primary' color="primary" onClick={()=>{setCreateModalIsOpen(true)}}>{add_text}</Button>
                </div>
            </div>
            <DataTable
                pagination 
                paginationServer
                paginationComponentOptions ={{
                    noRowsPerPage:true
                }}
                paginationTotalRows={totalElements} 
                onChangeRowsPerPage={handlePerRowsChange} 
                onChangePage={handlePageChange}
                striped={true}
                center={true}
                columns={columns}
                data={list.map(row => {
                    return {
                      ...row,
                      active: <XToggleButton checked={!row.disabled} onClick={()=>{updateTypeActive(row)}} />,
                      actions: <div className='flex'>
                                    <Link to={`/orders/ordertypes/details?id=${row.id}`} ><IconButton icon={
                                        <span className='action-box large update-btn'>
                                            <i className='icon'>
                                                <i className='icon-eye'></i>
                                            </i>
                                        </span>
                                        }
                                        text={view_details_text}
                                        onClick={()=>{}}
                                        color="info"
                                    />
                                    </Link>
                                    <IconButton icon={
                                        <span className='action-box large update-btn'>
                                            <i className='icon'>
                                                <i className='icon-pencil'></i>
                                            </i>
                                        </span>
                                        }
                                        text={edit_text}
                                        onClick={()=>{setSelectedRow(row);setEditModalIsOpen(true); }}
                                        color="warning"
                                    />
                                    <IconButton icon={
                                        <span className='action-box large delete-btn' title='Delete Task'>
                                            <i className='icon'>
                                                <i className='icon-trash'></i>
                                            </i>
                                        </span>
                                        }
                                        text={delete_text}
                                        onClick={()=>{handleDelete(row.id)}}
                                        color="danger"
                                    />
                                </div>
                    }
                  })}
                />
            
            
            <CreateOrderTypeModal 
                isVisible= {createModalIsOpen} 
                onCreate={onCreate} 
                onCancel= {()=>{setCreateModalIsOpen(false)}}
            />

            <EditOrderTypeModal 
                isVisible= {editModalIsOpen} 
                onEdit={onEdit} 
                onCancel= {()=>{setEditModalIsOpen(false)}}
                pages={[]}
                oldRow={selectedRow}
            />
            <LoadingSpinner isVisible={loading} />
            <ToastContainer />
            <ConfirmationModal 
                isVisible={isConfirmationModalOpen} 
                description={confirmationModalData.description} 
                onSubmit={confirmationModalData.onSubmit} 
                onCancel={confirmationModalData.onCancel}
                />
        </div>
      
      )
}

export default OrdertypesView;